module.exports = __webpack_public_path__ + "img/firefox-1.c6ee7d11.svg";